import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { color } from '../templates/Ui';
const StyledCanvas = styled.div `
    position: fixed;
    top: 65px;
    left: 0;
    transform: ${props => props.isVisible ? 'translateX(0%)' : 'translateX(-100%)'};
    padding: 55px 20px;
    width: 100%;
    max-width: 280px;
    height: 100%;
    min-height: 100%;
    background-color: ${color.body.base};
    transition: transform 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
    z-index: 6;
    overflow-y: auto;

    @media only screen and (min-width: 1400px) {
        position: fixed;
        left: auto;
        transform: none;
        z-index: 2;
        box-shadow: 0 0 5px 4px rgba(0, 0, 0, 0.11);
    }
`;
const Backdrop = styled.div `
    display: ${props => (props.isVisible ? 'inherit' : 'none')};
    opacity: ${props => (props.isVisible ? '1' : '0')};
    transition: opacity 0.2s ease-in-out;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.65);
    z-index: 5;

    @media only screen and (min-width: 1400px) {
        display: none;
        opacity: 0;
        pointer-events: none;
    }
`;
const OffCanvas = ({ children, isVisible, onClose, }) => (_jsxs(_Fragment, { children: [_jsx(StyledCanvas, { isVisible: isVisible, children: children }), _jsx(Backdrop, { isVisible: isVisible, onClick: onClose })] }));
export default OffCanvas;
